import React from 'react';
import { Drawer, IconButton } from '@mui/material';
import {CloseButton, EditWithIcon} from "components";
import { Images } from 'utils'

const DRAWER_WIDTH = 640;

/**
 * Right-side slide-in drawer that hosts a clearinghouse setup guide
 * (Office Ally / Availity). Presentational shell only — step content is passed
 * as `children`. Matches Figma (node 34892-118847): "Setup Guide" eyebrow +
 * bold title, close button, scrollable body.
 */
export const SetupGuideDrawer = ({ open, onClose, title, children }) => {
    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            sx={{ zIndex: 1300 }}
            PaperProps={{ sx: { width: { xs: '100%', sm: DRAWER_WIDTH }, maxWidth: '100%' } }}
        >
            <div className="setup-guide-drawer">
                <div className="setup-guide-header">
                    <div>
                        <p className="setup-guide-eyebrow">Setup Guide</p>
                        <p className="setup-guide-title">{title}</p>
                    </div>
                    <CloseButton handleCLic={onClose} />
                </div>
                <div className="setup-guide-body">{children}</div>
            </div>
        </Drawer>
    );
};
